import { render } from "./TicketHistory.vue?vue&type=template&id=b5c9978a&scoped=true"
import script from "./TicketHistory.vue?vue&type=script&lang=js"
export * from "./TicketHistory.vue?vue&type=script&lang=js"

import "./TicketHistory.vue?vue&type=style&index=0&id=b5c9978a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c9978a"]])

export default __exports__